import { render, staticRenderFns } from "./PhotosTile.vue?vue&type=template&id=2abc15df&scoped=true"
import script from "./PhotosTile.vue?vue&type=script&lang=js"
export * from "./PhotosTile.vue?vue&type=script&lang=js"
import style0 from "./PhotosTile.vue?vue&type=style&index=0&id=2abc15df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc15df",
  null
  
)

export default component.exports